import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { id: "interactW" }),
  /*#__PURE__*/_createElementVNode("span", { id: "interactH" }),
  /*#__PURE__*/_createElementVNode("span", { id: "interactX" }),
  /*#__PURE__*/_createElementVNode("span", { id: "interactY" })
], -1)
const _hoisted_3 = { class: "header__values" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("W")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("H")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("X")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Y")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "inner" }
const _hoisted_14 = { class: "visualisation-wrapper" }
const _hoisted_15 = { class: "visualisation" }
const _hoisted_16 = { class: "sidebar" }
const _hoisted_17 = { class: "properties" }
const _hoisted_18 = { class: "tools" }
const _hoisted_19 = {
  key: 0,
  class: "icon--text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_textfield = _resolveComponent("ui-textfield")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_SimpleFileUpload = _resolveComponent("SimpleFileUpload")!
  const _component_ui_item_text_content = _resolveComponent("ui-item-text-content")!
  const _component_ui_radio = _resolveComponent("ui-radio")!
  const _component_ui_item_last_content = _resolveComponent("ui-item-last-content")!
  const _component_ui_item = _resolveComponent("ui-item")!
  const _component_ui_list = _resolveComponent("ui-list")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_ui_fab = _resolveComponent("ui-fab")!
  const _component_ui_menu = _resolveComponent("ui-menu")!
  const _component_ui_menu_anchor = _resolveComponent("ui-menu-anchor")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["visualisations", { fullscreen: _ctx.fullscreen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ui_textfield, {
            modelValue: _ctx.values.w,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.w) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_ui_textfield, {
            modelValue: _ctx.values.h,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.h) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_ui_textfield, {
            modelValue: _ctx.values.x,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.x) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_ui_textfield, {
            modelValue: _ctx.values.y,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.y) = $event))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_ui_button, {
            outlined: "",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fullscreen = !_ctx.fullscreen))
          }, {
            default: _withCtx(() => [
              (_ctx.fullscreen)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Exit fullscreen"))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, "Fullscreen"))
            ]),
            _: 1
          }),
          (_ctx.editState)
            ? (_openBlock(), _createBlock(_component_ui_button, {
                key: 0,
                class: "btn--cancel",
                onClick: _ctx.onCancelAction,
                raised: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ui_button, {
            onClick: _ctx.onStoreAction,
            raised: "",
            disabled: [_ctx.editState && !_ctx.activeVisualisation.src].some((b) => b)
          }, {
            default: _withCtx(() => [
              (_ctx.editState)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Save"))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "Edit"))
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_SimpleFileUpload, {
            data: _ctx.activeVisualisation,
            model: 'settings',
            accept: '.svg',
            editState: _ctx.editState,
            onUpload: _ctx.onFileUpload,
            onFileRemove: _ctx.onFileRemove
          }, null, 8, ["data", "accept", "editState", "onUpload", "onFileRemove"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_ui_list, { role: "radiogroup" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeProperties, (item, index) => {
                return (_openBlock(), _createBlock(_component_ui_item, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_item_text_content, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ui_item_last_content, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ui_radio, {
                          modelValue: _ctx.checkedProperty,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkedProperty) = $event)),
                          value: item.value,
                          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["modelValue", "value"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolsItems, (item, i) => {
            return (_openBlock(), _createBlock(_component_ui_menu_anchor, {
              relative: "",
              key: i
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_fab, {
                  onClick: ($event: any) => (_ctx.menuOpen[item.name] = !_ctx.menuOpen[item.name])
                }, {
                  default: _withCtx(() => [
                    (item.name === 'type')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.stringFirstChar(_ctx.getActiveOptionsKeys.type_key)), 1))
                      : (_openBlock(), _createBlock(_component_SvgIcon, {
                          key: 1,
                          class: "icon--medium",
                          src: `icons/${_ctx.getIconPath(item.src, item.name)}`
                        }, null, 8, ["src"]))
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_ui_menu, {
                  position: "BOTTOM_END",
                  modelValue: _ctx.menuOpen[item.name],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.menuOpen[item.name]) = $event),
                  items: 
                [{ text: _ctx.titleCase(item.name), disabled: true }, '-'].concat(
                  item.items
                )
              ,
                  onSelected: _ctx.onSelected
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onSelected"])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_ui_fab, {
            icon: "add",
            title: "Add marker",
            onClick: _ctx.addMarker,
            class: _normalizeClass(["btn--add", {
              'btn--disabled': [
                !_ctx.editState,
                !_ctx.checkedProperty,
                _ctx.activeMarker.length > 0,
                !_ctx.activeVisualisation.src,
              ].some((b) => b),
            }])
          }, null, 8, ["onClick", "class"])
        ])
      ])
    ])
  ], 2))
}